// extracted by mini-css-extract-plugin
module.exports = {"bodyWrapper":"AccountUserButton_bodyWrapper__3aHMk","bodyText":"AccountUserButton_bodyText__20RD0","logoWrapper":"AccountUserButton_logoWrapper__2w3VW"};